<template lang="pug">
  .mobile-menu
      ul.mobile-menu__wrap
          li.mobile-menu__item
              router-link.mobile-menu__link(to='/inside-partners') {{tr.menu.title_1}}
          li.mobile-menu__item
              router-link.mobile-menu__link(to='/inside-team') {{tr.menu.title_2}}
          li.mobile-menu__item
              router-link.mobile-menu__link(to='/inside-shop') {{tr.menu.title_3}}
          //- each item in menu
          //-     li(class='mobile-menu__item')
          //-         a(class='mobile-menu__link ' href=item.link)&attributes(attributes)= item.title

      .main-content__border

      .mobile-menu__lang
          img(src="../../assets/images/ru.png", alt="", :class="{'mobile-menu__img-active': lang === 'ru'}", class="mobile-menu__img lang__img-ru", v-on:click="ru")
          img(src="../../assets/images/en.png", alt="", :class="{'mobile-menu__img-active': lang === 'en'}", class="mobile-menu__img lang__img-en", v-on:click="en")
          img(src="../../assets/images/ua.png", alt="", :class="{'mobile-menu__img-active': lang === 'ua'}", class="mobile-menu__img lang__img-ua", v-on:click="ua")
          img(src="../../assets/images/kz.png", alt="", :class="{'mobile-menu__img-active': lang === 'kz'}", class="mobile-menu__img lang__img-kz", v-on:click="kz")
          img(src="../../assets/images/mexico.png", alt="", :class="{'mobile-menu__img-active': lang === 'es'}", class="mobile-menu__img lang__img-kz", v-on:click="es")
      .main-content__border

      .header__authorizations
          .authorizations.mobile-menu__authorizations
              vButton.mobile-menu__btn( large white :href="linkSwitips + '/?locale='+lang_switips_link+'#register'", target="_blank" )
              vLogin
              //- +btn()(class='mobile-menu__btn btn_size_l', )
              //- +login()(class= 'login__title_color_grey')
</template>

<script>
import vButton from '../../components/elements/vButton'
import vLogin from '../../components/elements/vLogin'
import langOps from '@/mixins/langOps'

export default {
  data () {
    return {
      section: 'header'
    }
  },
  mixin: [langOps],
  computed: {
    linkSwitips () {
      return process.env.VUE_APP_SWITIPS
    }
  },
  components: {
    vButton,
    vLogin
  }
}
</script>
